/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { RunExecutionDetails } from '@/commons/protocols';

export const getExecutionSummaryData = (execution: RunExecutionDetails) => {
    const [pass, fail, other]: Array<{
        count: number;
        detail: Record<string, number>;
    }> = [
        { count: 0, detail: {} },
        { count: 0, detail: {} },
        { count: 0, detail: {} },
    ];
    for (const run of execution.runs) {
        if (run.storyDraft) {
            other.count++;
            other.detail.draft = (other.detail.draft || 0) + 1;
        } // not mututally exclusive, can be draft and passing

        if (run.storyEnabled === false) {
            other.count++;
            other.detail.disabled = (other.detail.disabled || 0) + 1;
        } else if (run.output === 'PASS') {
            pass.count++;
            if (run.storyMaintenance) {
                other.count++;
                other.detail.maintenance = (other.detail.maintenance || 0) + 1;
            }
        } else if (run.output === 'FAIL') {
            fail.count++;
            if (run.storyMaintenance) {
                other.count++;
                other.detail.maintenance = (other.detail.maintenance || 0) + 1;
            }
        } else if (run.output === 'PENDING') {
            other.count++;
            other.detail.review = (other.detail.review || 0) + 1;
        } else if (run.output === 'DISMISSED' && run.storyMaintenance) {
            other.count++;
            other.detail.maintenance = (other.detail.maintenance || 0) + 1;
        } else if (run.output === 'DISMISSED') {
            other.count++;
            other.detail.dismissed = (other.detail.dismissed || 0) + 1;
        } else if (!run.output && (run.status === 'running' || run.status === 'queued')) {
            other.count++;
            other.detail.running = (other.detail.running || 0) + 1;
        }
    }

    return {
        pass,
        fail,
        other,
    };
};
